'use client'

import { useCallback } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Container, Grid, Paper } from '@mui/material'
import { ErrorTwoTone as ErrorTwoToneIcon, LinkTwoTone as LinkTwoToneIcon } from '@mui/icons-material'

// Types
import type { PageProps } from '@/types/components/pages'

// Configurations
import Config from '@/config'

// Helpers
import Cookies from '@/helpers/cookies'

// Components
const PrimaryButtonAtom = dynamic(() => import('@/components/atoms/button/primary'))
const TitleTypographyAtom = dynamic(() => import('@/components/atoms/typography/title'))
const ParagraphTypographyAtom = dynamic(() => import('@/components/atoms/typography/paragraph'))

const NotFoundPage = (props: PageProps) => {
	// Props
	const { locale } = props

	// Callbacks
	const removeCookies = useCallback(async () => {
		// Remove cookies
		Cookies.remove(`${Config.shortName}-business-alias`)
		Cookies.remove(`${Config.shortName}-business-name`)
		Cookies.remove(`${Config.shortName}-business-branch-code`)
		Cookies.remove(`${Config.shortName}-business-branch-name`)
	}, [])

	return (
		<Grid sx={{ bgcolor: 'background.default' }}>
			<Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', height: '100dvh' }}>
				<Paper variant="outlined" sx={{ width: 1, borderRadius: 2 }}>
					<Grid
						container
						spacing={2}
						sx={{
							flexDirection: 'column',
							alignItems: 'center',
							py: 4,
							px: { xs: 1, md: 2 }
						}}
					>
						<Grid>
							<ErrorTwoToneIcon color="error" sx={{ fontSize: 100 }} />
						</Grid>

						<Grid>
							<TitleTypographyAtom text={locale.common.title.notFound} />
						</Grid>

						<Grid>
							<ParagraphTypographyAtom text={locale.common.description.notFound} />
						</Grid>

						<Grid>
							<Link href="/" onClick={() => removeCookies()}>
								<PrimaryButtonAtom text={locale.common.button.goHome} startIcon={<LinkTwoToneIcon />} />
							</Link>
						</Grid>
					</Grid>
				</Paper>
			</Container>
		</Grid>
	)
}

export default NotFoundPage
